import { Form, Formik } from 'formik';
import { useState } from 'react';

import authApis from '../../../APIs/auth';
import { ReactComponent as BuildingSVG } from '../../../assets/icons/building.svg';
import { ReactComponent as LocationSVG } from '../../../assets/icons/location.svg';
import { ReactComponent as MailSVG } from '../../../assets/icons/Mail.svg';
import { useRoot } from '../../../context/RootProvider';
import {
  Alert,
  Button,
  FormContainer,
  Input,
  Typography,
} from '../../../designComponents';
import { requestAPI } from '../../../utils';
import { ActiveComponentType } from '.';
import { ActionButtonContainer, Container } from './onboardingForms.style';
import validation from './validation';

const ContactInformation = ({
  setCurrentStep,
  initialState,
}: ActiveComponentType) => {
  const { updateAuth } = useRoot();
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  // const handleGoBack = () => setCurrentStep((prev) => prev - 1);
  const handleContinue = async (values: typeof initialState) => {
    try {
      setErrorMessage('');
      setLoading(true);
      const onBoardingData = await requestAPI(
        authApis.onBoarding({
          contactInfo: {
            address1: values.address1,
            address2: values.address2,
            city: values.city,
            country: values.country,
            postalCode: values.postalCode,
          },
          onboardingStep: 2,
        })
      );
      setLoading(false);
      updateAuth(onBoardingData.user);
      setCurrentStep((prev) => prev + 1);
    } catch (error: any) {
      if (typeof error === 'string') {
        setErrorMessage(error);
      }
      if (error.error && typeof error.error === 'string') {
        setErrorMessage(error.error);
      }
      console.error(error);
      setLoading(false);
    }
  };

  return (
    <Container>
      <Typography variant="title" className="title">
        Contact Information
      </Typography>
      {errorMessage && (
        <div style={{ marginBottom: '5px' }}>
          <Alert text={errorMessage} type="error" />
        </div>
      )}
      <Formik
        initialValues={initialState}
        enableReinitialize
        onSubmit={handleContinue}
        validationSchema={validation.contactInformation}
      >
        {({ values, setFieldValue, handleSubmit, touched, errors }) => {
          return (
            <Form onSubmit={handleSubmit}>
              <FormContainer
                label="Address Line 1"
                error={touched.address1 ? errors.address1 : ''}
                marginBottom="20px"
              >
                <Input
                  value={values.address1 || ''}
                  onChange={(e) => setFieldValue('address1', e.target.value)}
                  iconLeft={<LocationSVG />}
                  placeholder="Address line 1"
                />
              </FormContainer>
              <FormContainer
                label="Address Line 2"
                error={touched.address2 ? errors.address2 : ''}
                marginBottom="20px"
              >
                <Input
                  value={values.address2 || ''}
                  onChange={(e) => setFieldValue('address2', e.target.value)}
                  iconLeft={<MailSVG />}
                  placeholder="Address Line 2"
                />
              </FormContainer>
              <FormContainer
                label="City"
                error={touched.city ? errors.city : ''}
                marginBottom="20px"
              >
                <Input
                  value={values.city}
                  onChange={(e) => setFieldValue('city', e.target.value)}
                  iconLeft={<BuildingSVG />}
                  placeholder="City"
                />
              </FormContainer>
              <FormContainer
                label="Country"
                error={touched.country ? errors.country : ''}
                marginBottom="20px"
              >
                <Input
                  value={values.country}
                  onChange={(e) => setFieldValue('country', e.target.value)}
                  iconLeft={<BuildingSVG />}
                  placeholder="Country"
                />
              </FormContainer>
              <FormContainer
                label="Eircode / Postal Code"
                error={touched.postalCode ? errors.postalCode : ''}
                marginBottom="20px"
              >
                <Input
                  value={values.postalCode}
                  onChange={(e) => setFieldValue('postalCode', e.target.value)}
                  iconLeft={<MailSVG />}
                  placeholder="Eircode / Postal Code"
                />
              </FormContainer>
              <ActionButtonContainer>
                <Button
                  variant="gray"
                  width="93px"
                  onClick={() => setCurrentStep((prev) => prev - 1)}
                >
                  Back
                </Button>
                <Button
                  variant="secondary"
                  width="120px"
                  htmlType="submit"
                  isLoading={loading}
                >
                  Continue
                </Button>
              </ActionButtonContainer>
            </Form>
          );
        }}
      </Formik>
    </Container>
  );
};

export default ContactInformation;
